import { render, staticRenderFns } from "./TrustPilotReviews.vue?vue&type=template&id=ac4e0f74&scoped=true&"
import script from "./TrustPilotReviews.vue?vue&type=script&lang=js&"
export * from "./TrustPilotReviews.vue?vue&type=script&lang=js&"
import style0 from "./TrustPilotReviews.vue?vue&type=style&index=0&id=ac4e0f74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4e0f74",
  null
  
)

export default component.exports